import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useTranslation } from 'react-i18next';

export function InputFormField() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();
  return (
    <FormField
      control={form.control}
      name="titel"
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel>
            {t('domain.termine.sheet.fields.titel')}
            <span>*</span>
          </FormLabel>
          <FormControl>
            <Input
              {...field}
              onChange={field.onChange}
              autoComplete="off"
              className="h-10"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
